<template>
  <MainWrapper>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <!-- <div class="col-lg-4">
                    <div class="white-panel spec-categories">
                        <div class="spec-categories-header mb-15">
                            <h4>Все компании</h4>
                            <span class="dark-body-text spec-count">{{ coCount }}</span>
                        </div>
                        <div class="very-light-gray-line mb-15"></div>
                        <div class="spec-categories-body">
                            <div class="spec-categories-single mb-15" v-for="cat in categories" :key="cat.id">
                                <div class="checkbox pressed mr-15">
                                    <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                                </div>
                                <span class="dark-body-text">{{ cat.name }}</span>
                                <font-awesome-icon :icon="['fal', 'angle-right']" class="icon" />
                            </div>
                        </div>
                        <div class="very-light-gray-line mb-30"></div>
                        <Button type="blue" text="Показать результаты" />
                    </div>
                </div> -->
                <div class="col-lg-12">
                    <div class="container-fluid no-p">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="mb-15">Учреждения нашего сервиса</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mb-30">
                                    <Paginator :pages='pages' v-if="pages > 1" :current='page' v-on:change-page="(p) => page = p" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4" v-for="company in companies" :key="company.id">
                                <Company :name="company.name"
                                         :rating="company.rating"
                                         :cats="company.categories"
                                         :desc="company.short_info"
                                         :state="company.opened_now"
                                         :address="'г. Бишкек'"
                                         :img="company.photo"
                                         :slug="company.slug"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <Paginator :pages='pages' v-if="pages > 1" :current='page' v-on:change-page="(p) => page = p" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../../styles/main.core.vars.styl';

    .spec-categories
        padding: 20px 60px 30px 20px

    .spec-categories-header
        display: flex
        .spec-count
            margin: 0 0 0 auto
            color: $gray_text

    .spec-categories-single
        display: flex
        align-items: center
        >.icon
            margin-left: auto
            font-size: 16px
    
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Company from '@/components/Company.vue';
    import Paginator from '@/components/Paginator.vue';
    import moment from "moment";
    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            Company,
            Paginator
        }
    })
    export default class Companies extends Vue {

        companies = [];
        categories = [
            {
                id: 0,
                name: 'Красота'
            },
            {
                id: 1,
                name: 'Медицина'
            },
            {
                id: 2,
                name: 'Образование'
            },
            {
                id: 3,
                name: 'Ремонт личных вещей'
            },
            {
                id: 4,
                name: 'Работы по дому'
            },
            {
                id: 5,
                name: 'Организация мероприятий'
            },
            {
                id: 6,
                name: 'Профессиональные услуги'
            },
            {
                id: 7,
                name: 'Авто'
            },
            {
                id: 8,
                name: 'Электроприборы'
            },
        ]

        page = 1;
        pages = 0;

        coCount = 0;

        moment = moment;

        week = ['', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

        @Watch('page', {deep: true, immediate: true})
        onPageChange() {
            this.getCompanies();
        }

        getCompanies() {
            http("companies", "get", false, {
                page: this.page,
                limit: 9,
            }).then(
                r => {
                    this.companies = r.data.results;
                    this.companies.map((m) => {
                        console.log(m.times);
                        let work_time = m.times.find(i => i.week_day === this.week[moment().weekday()]);
                        if (work_time) {
                            let start_time = work_time.time.start_time;
                            let end_time = work_time.time.end_time;
                            let current_time = moment().format("HH:mm");
                            start_time = start_time.replace(':', '');
                            end_time = end_time.replace(':', '');
                            current_time = current_time.replace(':', '');
                            start_time = start_time.indexOf('0') == 0 ? start_time.substring(1) : start_time;
                            end_time = end_time.indexOf('0') == 0 ? end_time.substring(1) : end_time;
                            current_time = current_time.indexOf('0') == 0 ? current_time.substring(1) : current_time;
                            if (parseInt(current_time) > parseInt(start_time) && parseInt(current_time) < parseInt(end_time)) {
                                m.opened_now = true;
                            } else {
                                m.opened_now = false;
                            }
                        }
                    });
                    this.pages = Math.ceil(r.data.count / 9);
                    this.coCount = r.data.count;
                }
            );
        }

        created() {
            this.getCompanies();
        }


    }
</script>